import React, { FC } from 'react';
import { Modal } from 'antd';

type Props = {
  showModal: boolean;
  message: string;
  onCancel: () => void;
};

const PublishInfo: FC<Props> = ({ showModal, message, onCancel }) => {
  return (
    <Modal title='Publish Error Info' cancelText='Close' okButtonProps={{ hidden: true }} visible={showModal} onCancel={onCancel}>
      <span style={{ whiteSpace: 'pre-wrap' }}>{message}</span>
    </Modal>
  );
};

export default PublishInfo;
